
import React from "react";

function isImage(url: string) {
  return /\.(jpg|jpeg|png|gif|bmp|webp|svg)(\?.*)?$/i.test(url);
}

function isValidUrl(url: string) {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
}

interface WorksheetLinksCellProps {
  worksheet_urls?: string[];
  worksheet_drive_link?: string;
}

export const WorksheetLinksCell: React.FC<WorksheetLinksCellProps> = ({
  worksheet_urls,
  worksheet_drive_link
}) => (
  <>
    {/* Worksheet Attachments */}
    <td>
      {Array.isArray(worksheet_urls) && worksheet_urls.length > 0 ? (
        <ul className="list-disc ml-4 space-y-1 text-blue-600">
          {worksheet_urls.map((url, i) => {
            const displayName = isImage(url)
              ? `ดาวน์โหลดรูปภาพ ${i + 1}`
              : `ดาวน์โหลดไฟล์ ${i + 1}`;
            return (
              <li key={url + String(i)}>
                <a
                  href={url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline"
                >
                  {displayName}
                </a>
              </li>
            );
          })}
        </ul>
      ) : (
        "-"
      )}
    </td>
    {/* Worksheet Drive Link */}
    <td>
      {worksheet_drive_link && isValidUrl(worksheet_drive_link) ? (
        <a
          href={worksheet_drive_link}
          target="_blank"
          rel="noopener noreferrer"
          className="text-blue-600 underline break-all"
        >
          เปิดลิงก์
        </a>
      ) : (
        "-"
      )}
    </td>
  </>
);
